import React from "react";
import { Box, Container } from "@mui/material";
import HelpCenterHeader from "../../Components/HelpCenter/HelpCenterHeader";
import HelpCenterSearch from "../../Components/HelpCenter/HelpCenterSearch";
import Footer from "../../Components/Common/Footer";

const HelpCenter = () => {
  return (
    <div>
      <HelpCenterHeader />
      <HelpCenterSearch />
      {/* <Container maxWidth="lg" sx={{ marginTop: 4 }}>
        <h2>HelpCenter Content Goes Here</h2>
      </Container> */}
      <Footer />
    </div>
  );
};

export default HelpCenter;
